
export const breakpoints = {
  xs: "@media screen and (max-width: 599.9px)",
  sm: "@media screen and (min-width: 600px) and (max-width: 959.9px)",
  smDown: "@media screen and (max-width: 959.9px)",
  smUp: "@media screen and (min-width: 600px)",
};
